import { useContext } from 'react';

import { SidebarCollapseContext } from '../context/SidebarCollapseContext';

export const useSidebarCollapse = () => {
  const value = useContext(SidebarCollapseContext);

  return value;
};
